<template>
  <ScModal
    :show="show"
    class="address-modal Modal"
    @close="close"
  >
    <form
      @submit.prevent="onSubmit"
      novalidate
    >
      <div class="modal-header">
        <h5 class="modal-title">
          {{ $t(`account.modal.changeSellerName`) }}
        </h5>
        <button
          type="button"
          class="close"
          @click="close"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="input-wrapper">
          <ScLabel>
            {{ $t(`account.labels.${input.key}`) }}
          </ScLabel>
          <ScInput
            :is-invalid="errors.has(input.key)"
            :disabled="input.disabled"
            v-validate="input.validation"
            :data-vv-name="input.key"
            :name="input.key"
            v-model="input.value"
            :placeholder="$t(`account.placeholder.${input.key}`)"
          />
          <span
            v-if="errors.has(input.key)"
            class="error-message"
          >
            {{ errors.first(input.key) }}
          </span>
        </div>
        <div class="rules-wrapper">
          <span>{{ $t('account.sellerNameModal.ruleTitle') }}</span>
          <ul class="rules">
            <li
              class="rule"
              :key="i"
              v-for="i in 7"
            >
              - {{ $t(`account.sellerNameModal.rules.rule${i}`) }}
            </li>
          </ul>
        </div>
        <div class="input-checkbox-wrapper">
          <ScCheckbox
            class="form-checkbox"
            v-model="isConfirmed"
            name="confirmation"
          />
          <span>
            {{ $t(`account.sellerNameModal.infoMessage`) }}
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <ScButton
          type="submit"
          class="form-button"
          :disabled="!canSubmit"
        >
          {{ $t(`account.save`) }}
        </ScButton>
      </div>
    </form>
  </ScModal>
</template>

<script>
import ScButton from '@trendyol/sc-ui-kit/ScButton';
import ScCheckbox from '@trendyol/sc-ui-kit/ScCheckbox';
import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import ScInput from '@trendyol/sc-ui-kit/ScInput';
import ScModal from '@trendyol/sc-ui-kit/ScModal';

export default {
  name: 'SellerNameModal',
  components: { ScInput, ScButton, ScLabel, ScModal, ScCheckbox },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    const validations = {
      name: {
        required: 'Mağaza adı',
        minChar: [3, 'Mağaza adı'],
        max: 40,
        turkishText: '&-\\d',
      },
    };

    return {
      validations,
      originalSellerName: this.data.name || '',
      input: {
        value: '',
        key: 'sellerName',
        type: 'text',
        validation: validations.name,
        className: 'seller-name',
      },
      isConfirmed: false,
    };
  },
  methods: {
    close () {
      this.errors.clear();
      this.$emit('close');
    },
    onSubmit () {
      return this.$validator.validate().then(valid => {
        if (!valid) {
          return false;
        }
        this.$emit('submit', {
          ...this.input,
          value: this.input.value.trim(),
        });
      });
    },
  },
  computed: {
    canSubmit () {
      return this.isConfirmed && (this.originalSellerName === '' ||
        this.originalSellerName !== this.input.value.trim());
    },
  },
  created () {
    const dict = {
      custom: {
        sellerName: {
          max: this.$t('account.sellerNameModal.errors.max', { value: 40 }),
        },
      },
    };

    this.$validator.localize('tr', dict);
  },
  watch: {
    data: {
      handler () {
        this.input.value = this.data.name || '';
        this.originalSellerName = this.input.value;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .address-modal{
    position: fixed !important;

    ::v-deep .modal-dialog {
      max-height: unset !important;
    }

    & .modal-header{
      padding: 35px 30px 25px 30px;
      & .modal-title{
        font-size: 20px !important;
      }
    }
    & .modal-body{
      padding: 0 30px;

      ::v-deep .mp-label {
        margin-bottom: 3px;
        display: inline-block;
        .icon {
          display: none;
        }
      }

      .info-container{
        display: flex;
        align-items: center;
        margin-top: 30px;
        & .info-text{
          font-size: 14px;
          margin-left: 10px;
          color: #f27a1a;
        }
      }

      .rules-wrapper {
        margin-top: 20px;
        span {
          font-size: 14px;
          font-weight: 500;
          color: #273142;
          display: inline-block;
          margin-bottom: 13px;
        }

        .rules {
          margin: 0 !important;
          padding: 0 !important;
          li {
            list-style: none;
            font-size: 12px;
            color: #273142;
            &:not(:last-child) {
              margin-bottom: 13px;
            }

            img, span {
              margin-right: 8px;
            }
          }
        }
      }

      .input-checkbox-wrapper{
        display: flex;
        align-items: center;
        margin-top: 30px;

        span{
          margin-left: 8px;
          font-size: 14px;
        }

        ::v-deep .mp-checkbox{
          min-width: 16px;
        }
      }
    }
    & .modal-footer{
      padding: 30px;
      border-top: none;
      & .form-button {
        width: 100%;
        height: 40px;
      }
    }
    & .error-message{
      font-size:12px;
      color:#dc3545;
      position: absolute;
    }
    .input-wrapper {
      position: relative;
    }
  }
</style>
